// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"6fa9a8ba","32":"7ddfb10e","206":"9b22d761","460":"6545d446"}[chunkId] + ".chunk.js";
};